module.exports = __webpack_public_path__ + "static/media/sign-up-modal.f1096d37.png";